export const ParticipantsLoadingIndicator = () => {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className="flex items-center justify-between space-x-4 animate-pulse"
        >
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 rounded-full bg-skeleton"></div>
            <div className="h-4 w-24 bg-skeleton rounded"></div>
          </div>
          <div className="h-6 w-16 bg-skeleton rounded"></div>
        </div>
      ))}
    </div>
  )
}
